/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {ClientModel} from '../../../../model'
import {getClient} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useEnterprise, useCompany} from '../../../../hooks'
const TableClient: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const {enterprise, getEnterpriseList} = useEnterprise()
  const {companyList, getCompanyList} = useCompany()

  const getClientList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getClient(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getEnterpriseList()
    getCompanyList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getClientList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getClientList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])
  const handleViewPanel = (rowData: any) => {
    const getRow = rowData.row
    const getArrows = rowData.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-client',
      },
      idToDelete: '',
    }
    clearSelected()
    changeCurrentTabItem(obj)
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<ClientModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de documento - compañía'
            name={'rucCompania'}
            searcheable
          />
        ),
        accessor: 'rucCompania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'companiaId'}
            data={companyList}
            selecteable
          />
        ),
        accessor: 'nombreCompania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de documento - cliente'
            name={'rucEmpresa'}
            searcheable
          />
        ),
        accessor: 'rucEmpresa',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'EmpresaId'}
            data={enterprise}
            selecteable
          />
        ),
        accessor: 'nombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [companyList, enterprise, selectedOn],
  )

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

export {TableClient}
